import React, { useEffect, useState } from 'react';
import parse from "html-react-parser";
import {
  Grid,
  Paper
} from '@material-ui/core';

import wpServices from 'Services/wpService';
import CommonLoader from 'Views/Common/CommonLoader';
import clsx from 'clsx';
import LayoutView from "Views/Common/LayoutView";
import { SectionHeader } from 'components';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const TermsConditions = () => {
  const [termsContent, setContent] = useState();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const getTermsConditions = async () => {
        const response = await wpServices.getTermsConditions("/legal-pages?filters[slug][$eq]=terms-of-service&populate=*");        
        setContent(response);
        setLoading(false);
    };

    getTermsConditions();
  }, []);

  return (
    <>
      <SectionHeader
        title=""
        rightSection={
          <Paper className={clsx('widget-wrapper')} elevation={0}>

            {
              isLoading ?
                <CommonLoader />
                :
                <Grid item xs={12}>
                  {termsContent?.data?.revision_notice && (
                    <div style={{ 
                      marginTop: '20px', 
                      marginBottom: '24px',
                      padding: '16px 20px', 
                      backgroundColor: '#f5f5f5', 
                      borderRadius: '6px',
                      fontSize: '14px',
                      color: '#666',
                      lineHeight: '1.5'
                    }}>
                      {termsContent?.data?.revision_notice}
                    </div>
                  )}
                  <div style={{
                    fontSize: '20px',
                    lineHeight: '1.6',
                    color: '#333'
                  }}>
                    <style>
                    {`
                      .terms-content p {
                        margin: 0 0 16px 0 !important;
                        line-height: 1.6;
                        font-size: 16px;
                        color: #333;
                      }
                      .terms-content h1, 
                      .terms-content h2, 
                      .terms-content h3, 
                      .terms-content h4, 
                      .terms-content h5, 
                      .terms-content h6 {
                        margin: 24px 0 16px 0 !important;
                        font-weight: 600;
                        color: #333;
                      }
                      .terms-content h4 { font-size: 24px; }
                      .terms-content h6 { font-size: 14px; }
                    `}
                    </style>
                    <div className="terms-content">
                      {termsContent?.data?.description ? (
                        <ReactMarkdown 
                          remarkPlugins={[remarkGfm]}
                          rehypePlugins={[rehypeRaw]}
                        >
                          {termsContent?.data?.description}
                        </ReactMarkdown>
                      ) : (
                        <p>No content available</p>
                      )}
                    </div>
                  </div>
                </Grid>
            }

          </Paper>

        }
      >
      </SectionHeader>
    </>
  )
};

export default TermsConditions;
